module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Oberriet-3ed5d1e9cae253dd3921d01cdc58f8fc.png";